import { Features } from '@src/contexts/features-context/types';

type GetFeatureListParams = {
  isWhiteLabel: boolean;
  areMemberBenefitsEnabled: boolean;
  npsSurveyCopyAbExperiment: boolean;
  isMultipleBreakfastPartnerSelectionEnabled: boolean;
  upgradeUpsellEnabled: boolean;
  tmNativeSignupModal: boolean;
};

export const getFeatureList = ({
  isWhiteLabel,
  areMemberBenefitsEnabled,
  npsSurveyCopyAbExperiment,
  isMultipleBreakfastPartnerSelectionEnabled,
  upgradeUpsellEnabled,
  tmNativeSignupModal,
}: GetFeatureListParams): Features => ({
  guestAccount: {
    active: !isWhiteLabel,
  },
  memberBenefits: {
    active: areMemberBenefitsEnabled,
  },
  npsSurveyCopyAbExperiment: {
    active: npsSurveyCopyAbExperiment,
  },
  isMultipleBreakfastPartnerSelectionEnabled: {
    active: isMultipleBreakfastPartnerSelectionEnabled,
  },
  upgradeUpsell: {
    active: upgradeUpsellEnabled,
  },
  tmNativeSignupModal: {
    active: tmNativeSignupModal,
  },
});
